import useHeader from 'hooks/useHeader';
import useTitle from 'hooks/useTitle';
import { Route, Switch } from 'react-router-dom';
import { headerTitle, BROWSER_TITLE } from 'utilities';
import routes from './web2PublishNavigations';

const Routes = () => {
  useHeader(headerTitle.web2Publish);
  useTitle(BROWSER_TITLE.W2P);
  return (
    <Switch>
      {routes.map((route) => {
        return (
          <Route
            path={route.path}
            key={route.path}
            component={route.component}
            {...route}
          />
        );
      })}
    </Switch>
  );
};

export default Routes;
